import { render, staticRenderFns } from "./ProposalProductFilters.vue?vue&type=template&id=51dc8ed9&"
import script from "./ProposalProductFilters.vue?vue&type=script&lang=js&"
export * from "./ProposalProductFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports